<template>
  <div class="animated fadeIn">
    <loader v-if="loading"></loader>
    <component-header
      title="User Management"
      @search-query="(val) => (filter = val)"
      :isLoading="loading"
      @reload-data="getSubtanentList"
      :hasReload="true"
      @create-press="createUserRoute"
      :hasback="true"
      @back-press="$router.push('./dashboard')"
    />
    <b-card class="card-wrap" border-variant="info">
      <div>
        <b-table
          style="border-radius: 12px"
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive
          class="tableRadius"
          :items="tenantSubAdmins"
          :fields="tenantColumns"
          :per-page="perPage"
          :filter="filter"
          thead-class="header"
          show-empty
          :busy="loading"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="status" slot-scope="data">
            <div class="table-row">{{ data.item.status || "ACTIVE" }}</div>
          </template>
          <template slot="action" slot-scope="data">
            <div class="inline_btnTable">
              <b-button
                size="sm"
                class="button-circle mr-2"
                variant="primary"
                @click="viewUser(data.item)"
              >
                <i class="fa fa-eye"></i>
              </b-button>

              <b-button
                size="sm"
                class="button-circle mr-2"
                style="background: #fe7b08; border: #fe7b08"
                variant="primary"
                @click="editUser(data.item)"
              >
                <i class="fa fa-pencil edit"></i>
              </b-button>

              <b-button
                size="sm"
                class="button-circle"
                @click="deleteUser(data.item)"
                variant="danger"
              >
                <i class="fa fa-trash"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
      <div style="float: right">
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="userListMeta.total"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
          @change="getTenantData"
        ></b-pagination>
      </div>
    </b-card>
  </div>
</template>
<script>
import ComponentHeader from "@/components/componentNewHeader";
import loader from "@/components/loader/nipigeloader.vue";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "userlist",
  components: {
    ComponentHeader,
    loader,
  },
  data() {
    return {
      filterCount: 0,
      loading: false,
      perPage: 10,
      currentPage: 1,
      filter: "",
      loading: false,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      context: "Add",
      sortBy: "createdAt",
      sortDesc: true,
      tenantColumns: [
        {
          key: "fullName",
          label: "Name",
          sortable: true,
        },
        {
          key: "city",
        },
        {
          key: "email",
        },
        {
          key: "phone",
        },
        {
          key: "meta.kycStatus",
          label: "Kyc Status",
        },
        {
          key: "status",
          label: "User Status",
        },
        {
          key: "category",
        },
        {
          key: "action",
        },
      ],
      status: "ACTIVE",
    };
  },
  computed: {
    ...mapState({
      userListMeta: (state) => state.tenant.userListMeta,
    }),
    tenantSubAdmins() {
      let data = this.$store.getters["tenant/GetTenantSubAdminList"];
      let tenantList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          let arrayObj = {
            _id: obj._id,
            city: obj?.address?.city,
            state: obj?.address?.state,
            country: obj?.address?.country,
            zip: obj?.address?.zip,
            userName: obj?.authentication?.userName,
            email: obj?.authentication?.email,
            phone: obj?.authentication?.phone,
            fullName: `${obj.name.first} ${obj.name.last}`,
            password: "",
            status: obj?.status,
            orgAccessLevel: obj?.authorization?.orgAccess?.orgAccessLevel,
            category: obj?.authorization?.category,
            value: obj?.experience ? obj?.experience?.value : "",
            uom: obj?.experience ? obj?.experience?.uom : "",
            createdAt: obj?.createdAt,
            ...obj,
          };
          tenantList.push(arrayObj);
        });
        return tenantList;
      } else {
        this.loading = false;
        return [];
      }
    },
  },
  methods: {
    // onFilter(list) {
    //   this.filterCount = list.length;
    //   this.currentPage = 1;
    // },
    async getTenantData(e) {
      this.currentPage = e;
      await this.getSubtanentList();
    },
    createUserRoute() {
      this.$router.push({ name: "CreateUser" });
    },
    viewUser(data) {
      if (this.$router.history.current.name === "partner-user") {
        this.$router.push({
          name: "ViewUser",
          params: { userId: data._id, userData: data },
        });
      } else {
        this.$router.push({
          name: "View User",
          params: { userId: data._id, userData: data },
        });
      }
    },
    editUser(data) {
      if (data.status == "PENDING") {
        this.$swal({
          title: "Your Approval is Pending",
          text: "Get your Approval Done From Distributor",
          type: "warning",
        });
      } else {
        if (this.$router.history.current.name === "partner-user") {
          this.$router.push({
            name: "Edit User",
            params: { id: data._id, userData: data },
          });
        } else {
          this.$router.push({
            name: "EditUser",
            params: { id: data._id, userData: data },
          });
        }
      }
    },
    async deleteUser(data) {
      await this.$swal({
        title: "Are you sure?",
        text: "You can't revert this action!!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store.dispatch("tenant/deleteUser", data._id).then((result) => {
            this.$toasted.success("User Deleted Successfully");
            this.getSubtanentList();
          });
          this.isLoading = false;
        }
      });
    },
    async getSubtanentList() {
      this.loading = true;
      const payload = { limit: this.perPage, page: this.currentPage };
      await this.$store
        .dispatch("tenant/fetchTenantSubAdminList", payload)
        .then((data) => {
          if (data.message) {
            this.$toasted.error(data.message);
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  async mounted() {
    if (this.partnerAllData == null && this.$route.params.id) {
      await this.$store.dispatch("partner/fetchPartnerById", this.$route.params.id);
    }
    const tenantList = this.$store.getters["tenant/GetTenantSubAdminList"];
    this.getSubtanentList();
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
